import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './PageContainer.module.scss';

const s = classNames.bind(styles);

export default function PageContainer({ children }) {
	return <main className={s('container')}>{children}</main>;
}

PageContainer.propTypes = {
	children: PropTypes.object
};
